import Fetch, { pageInfo } from './fetch';
import Qs from 'qs'

const accessManage = {
    // 物品
    addGoodInout (param) {
        return Fetch({
            url: '/goodInOut/addGoodInout',
            method: 'post',
            data: param
        });
    },
    getGoodInoutList (param, page, size) {
        return Fetch({
            url: '/goodInOut/getGoodInoutList?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get'
        });
    },
    delGoodInout (id) {
        return Fetch({
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: '/goodInOut/delGoodInout',
            method: 'post',
            data: Qs.stringify({ id })
        });
    },
    // 人员出入
    addVisit (param) {
        return Fetch({
            url: '/visit/addVisit',
            method: 'post',
            data: param
        });
    },
    getVisitById (id) {
        return Fetch({
            url: '/goodvisitInOut/getVisitById?' + id,
            method: 'get'
        });
    },
    getVisitList (param, page, size) {
        return Fetch({
            url: '/visit/getVisitList?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get'
        });
    },
    delVisit (id) {
        return Fetch({
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: '/visit/delVisit',
            method: 'post',
            data: Qs.stringify({id})
        });
    },
    exportGoodInoutList (param, page, size) {
        return Fetch({
            url: '/exportData/exportGoodInoutList?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get'
        });
    },
    exportVisitList (param, page, size) {
        return Fetch({
            url: '/exportData/exportVisitList?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get'
        });
    },
}
export default accessManage;



// WEBPACK FOOTER //
// ./src/api/accessManage.js